
import Promise from "plugins/bluebird/index"
import log from "plugins/loglevel/index"
import ObjectFinder from "app/object-finder"


/* eslint-disable no-unused-vars */
enum RejectionReasons {
  TIMEOUT = "TIMEOUT",
}
/* eslint-enable no-unused-vars */
interface RejectionResult {
  rejection_reason: RejectionReasons,
  rejection_message: string,
}

interface TimeState {
  total_wait_time_ms: number,
  wait_interval_ms: number,
}

interface Options {
  wait_interval_ms:           number,
  wait_interval_increase_ms:  number,
  max_wait_interval_ms:       number,
  max_wait_time_ms:           number,
  should_log_timeout:         boolean,
}

interface InputOptions {
  wait_interval_ms?:           number,
  wait_interval_increase_ms?:  number,
  max_wait_interval_ms?:       number,
  max_wait_time_ms?:           number,
  should_log_timeout?:         boolean,
}

// ============== main ==================
const DEFAULT_OPTION = {
  wait_interval_ms:           50,
  wait_interval_increase_ms:  50,
  max_wait_interval_ms:       500,
  max_wait_time_ms:           30 * 1000,
  should_log_timeout:         true,
}

const dummyLoop = (condition: (() => boolean), onExit: (() => void), onTimeout: ((n: number) => void), option: Options, state: TimeState) => {
  const {max_wait_interval_ms, wait_interval_increase_ms, max_wait_time_ms} = option
  let {total_wait_time_ms, wait_interval_ms} = state

  const partialDummyLoop = (state_in_partial: TimeState) => {
    dummyLoop(condition, onExit, onTimeout, option, state_in_partial)
  }

  setTimeout(() => {
    if (condition()) {
      onExit()
    }
    else {
      // increment time wait for the last iteration
      total_wait_time_ms += wait_interval_ms
      // break part
      if (total_wait_time_ms >= max_wait_time_ms) {
        onTimeout(total_wait_time_ms)
        return
      }

      // linear increase on timeout for next iteration
      if (wait_interval_ms < max_wait_interval_ms) {
        wait_interval_ms += wait_interval_increase_ms
      }

      partialDummyLoop({total_wait_time_ms, wait_interval_ms})
    }
  }, wait_interval_ms)
}

const WaitObjectByPathPromise = (objectNameToWait: string, options: InputOptions = {}): Promise<any> => {
  return new Promise((resolve, reject) => {
    const total_wait_time_ms = 0
    const opts = Object.assign({}, DEFAULT_OPTION, options)
    const {wait_interval_ms, should_log_timeout} = opts
    const init_state = { total_wait_time_ms, wait_interval_ms }

    const stopCondition = () => ObjectFinder.findObjectByPath(objectNameToWait) != null
    const local_resolve = () => resolve(ObjectFinder.findObjectByPath(objectNameToWait))
    const onTimeout = (total_time: number) => {
      if (should_log_timeout) {
        log.debug(`WaitObjectByPathPromise waited ${objectNameToWait} for ${total_time / 1000}s, it failed to be defined/loaded`)
      }
      reject(({
        rejection_reason:  RejectionReasons.TIMEOUT,
        rejection_message: `WaitObjectByPathPromise waited ${objectNameToWait} for ${total_time / 1000}s, it failed to be defined/loaded`,
      } as RejectionResult))
    }

    if (stopCondition()) {
      local_resolve()
    }
    else {
      dummyLoop(stopCondition, local_resolve, onTimeout, opts, init_state)
    }
  })
}


export default WaitObjectByPathPromise

export {
  WaitObjectByPathPromise,
  RejectionReasons,
}
